import React from "react";
import styles from "./index.module.less";

/** 体验券跟单底栏：全宽提取收益 */
export default function CouponPositionActionBar({ onWithdraw, t }) {
  return (
    <div className={styles.bar} onClick={(e) => e.stopPropagation()}>
      <button type="button" className={styles.withdrawBtn} onClick={onWithdraw}>
        {t("aicopy.withdrawProfit")}
      </button>
    </div>
  );
}
